import React from 'react';
import { useAuth } from '../auth/AuthProvider';
import { useNavigate } from 'react-router-dom';

const RegistrationSuccessPage = () => {
    const { isAppLaunched } = useAuth();
    const navigate = useNavigate();

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            background: 'linear-gradient(180deg, #0b3a7a 0%, #0b234a 100%)'
        }}>
            <div className="content-card" style={{ maxWidth: '600px', textAlign: 'center' }}>
                <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                    <img src="/sruti-vaibhavam.png" alt="Event Logo" style={{ width: '150px', height: 'auto' }} />
                </div>
                <h2 style={{ marginBottom: '2rem' }}>Registration Successful!</h2>
                <p style={{ marginBottom: '2rem', color: '#333', lineHeight: 1.5 }}>
                    Thank you for registering.
                    {!isAppLaunched && (
                        <>
                            <br/>
                            You will be able to log in after our official launch on <strong>January 22, 2026</strong>.
                        </>
                    )}
                </p>
                {isAppLaunched && (
                    <button onClick={() => navigate('/login')} className="btn-primary" style={{ marginRight: '1rem' }}>
                        Go to Login
                    </button>
                )}
                <button onClick={() => navigate('/registration')} className="btn-secondary">
                    Register Another User
                </button>
            </div>
        </div>
    );
};

export default RegistrationSuccessPage;